import { createStore, sample } from 'effector';
import { alwaysNew } from '~/shared/lib/alwaysNew';
import { UniteTypeMarket } from '~/generated/payoutBackend/model';
import { getMeFx, logoutSucceeded } from '../../auth';
import { doesTraderExist } from './lib';
import { getBalanceFx, getMeTraderFx, updateWorkingStatusFx, verifyTraderFx } from './effects';
import { type Trader, WorkingStatus, TraderStatus, type Balance } from './model';

export const $traderInfo = createStore<Trader | null>(null)
    .on(getMeTraderFx.doneData, alwaysNew)
    .reset(logoutSucceeded);

export const $isTraderActive = $traderInfo.map((trader) => {
    return trader?.status === TraderStatus.STATUS_ACTIVE;
});

export const $allowedMarkets = $traderInfo.map((trader) => {
    return (trader?.config?.allowedMarkets ?? []).filter((market) => {
        return market !== UniteTypeMarket.MARKET_UNSPECIFIED;
    });
});

export const $isMarketRequired = $allowedMarkets.map((allowedMarkets) => {
    return allowedMarkets.length > 0;
});

export const $isTraderVerificationRequired = createStore(false)
    .on(getMeTraderFx.failData, doesTraderExist)
    .reset(getMeTraderFx, getMeTraderFx.doneData, verifyTraderFx.done, logoutSucceeded);

export const $workingStatus = createStore<WorkingStatus>(WorkingStatus.WORKING_STATUS_UNSPECIFIED)
    .on(getMeTraderFx.doneData, (_, { workingStatus }) => {
        return workingStatus;
    })
    .on(updateWorkingStatusFx.doneData, (_, { workingStatus }) => {
        return workingStatus;
    });

export const $balance = createStore<Balance[]>([]).on(getBalanceFx.doneData, (_, { balances }) => {
    return balances;
});

sample({
    clock: [verifyTraderFx.done, getMeFx.done],
    source: getMeTraderFx.pending,
    filter: (pending) => {
        return !pending;
    },
    fn: () => undefined,
    target: getMeTraderFx,
});

sample({
    clock: getMeTraderFx.doneData,
    filter: $isTraderActive,
    fn: () => undefined,
    target: getBalanceFx,
});

sample({
    clock: updateWorkingStatusFx.doneData,
    source: $traderInfo,
    fn: (trader, { workingStatus }) => {
        if (!trader) {
            return trader;
        }

        return {
            ...trader,
            workingStatus,
        };
    },
    target: $traderInfo,
});
